export default {
  //------------------------- 通用接口 -------------------------
  //支付fail结果message查询
  get_codeMessage: "/pay/message/query",
  //获取submit token
  post_submitToken: "/crypto/wallet/check",
  //首页
  get_basicData: "/nft/index",
  //支付方式列表
  get_payments: "/nft/payment",
  //创建订单
  post_createOrder: "/nft/trade/order",
  //nft支付
  get_pay: "/nft/agg/pay",
  //支付结果
  get_nftPayResult: "/nft/result/check",
  //查询商户信息
  get_merchantInfo: "/nft/merchant/info",
  //page商户币本位接入接入方式 - 费用信息
  post_feeInfo: "/nft/trade/getFiatAmount",
  //获取用户ip
  get_userIP: "/nft/client/ip",
  //用户支付表单数据
  get_payFormData: "/nft/get/user/pay/formData",

  //------------------------- 登陆接口 -------------------------
  //登陆
  post_login: "/user/login",
  //获取邮箱code
  post_sendEmail: "/mail/sending",
  //用户一键登陆接口
  getUserLogin: "/login/free/certification",
  //退出登陆
  post_outLogin: "/login/to-logout",

  //------------------------- 信用卡相关接口 -------------------------
  //保存卡信息
  post_saveCardInfo: "/user/card/submit",
  //信用卡信息删除
  post_deleteForm: "/user/card/delete/",

  //------------------------- 交易历史接口 -------------------------
  //退款信息
  get_sellRefundInfo: "/trade/sell/refund/page/data",
  //申请退款
  get_sellRefund: "/trade/sell/order/refund",
  //交易历史列表
  get_historyList: "/nft/trade/list",

  //------------------------- 支付统一接口 -------------------------
  //本地支付
  post_alchemyPay: "/nft/alchemyPay",

  //------------------------- KYC -------------------------
  // kyc检查
  get_check: "/kyc/check",
  // 获取kycToken
  get_getToken: "/kyc/getToken",
  // kyc onfido 提交
  get_onfidoCheckSubmit: "/kyc/onfidoCheckSubmit",
  // 获取当前用户kyc信息
  get_findUserDetail: "/kyc/findUserDetail",
  // 获取kyc用户cpf
  get_brazilCpf: "/kyc/user/brazil/cpf",
  // 获取kyc用户限额
  get_getQuota: "/kyc/getQuota",
  // kyc初始化
  get_kycRule: "/kyc/rule",
};
